import { render } from "./ListingTemplateSelectorWrapper.vue?vue&type=template&id=188cf469"
import script from "./ListingTemplateSelectorWrapper.vue?vue&type=script&lang=js"
export * from "./ListingTemplateSelectorWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__